import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Project, ProjectCreateParams, ProjectQueryParams, ProjectUpdateParams, ReportCreateParams } from '../models/project.model';
import { ListResponse } from '../models/utility.model';
import { ProjectGateway } from '../usecases/project.gateway';

@Injectable()
export class ProjectService extends ProjectGateway {
  constructor(private _http: HttpClient) {
    super();
  }

  listProjects(params: ProjectQueryParams): Observable<ListResponse<Project>> {
    return this._http.get<ListResponse<Project>>('api/vgs/projects', { params });
  }

  createProject(params: ProjectCreateParams): Observable<Project> {
    return this._http.post<Project>('api/vgs/projects', params);
  }

  updateProject(projectId: string, params: ProjectUpdateParams): Observable<Project> {
    return this._http.put<Project>(`api/vgs/projects/${projectId}`, params);
  }

  deleteProject(projectId: string): Observable<void> {
    return this._http.delete<void>(`api/vgs/projects/${projectId}`);
  }

  getConsentForm(projectId: string, consentId: string): Observable<{ url: string }> {
    return this._http.get<{ url: string }>(`api/vgs/projects/${projectId}/consent-forms/${consentId}`);
  }

  createReport(projectId: string, params: ReportCreateParams): Observable<Project> {
    return this._http.post<Project>(`api/vgs/projects/${projectId}/reports`, params);
  }
}
